import { z } from 'zod';
// Lifecycle of a manually granted matching boost (DEV-5507): Active until the partner received the
// boost's maximum number of matched leads (Consumed) or it is ended by hand (Revoked).
export const partnerManualBoostStatusSchema = z.enum(['Active', 'Consumed', 'Revoked']);
export const grantManualBoostInputSchema = z.object({
    reason: z.string().min(1),
    maxLeadUsages: z.number().int().positive().optional(),
});
export const revokeManualBoostInputSchema = z.object({
    reason: z.string().min(1),
});
export const partnerManualBoostSchema = z.object({
    uuid: z.uuid(),
    status: partnerManualBoostStatusSchema,
    maxLeadUsages: z.number().int(),
    usageCount: z.number().int(),
    remainingUsages: z.number().int(),
    reason: z.string(),
    grantedAt: z.iso.datetime(),
    revokedAt: z.iso.datetime().nullable(),
    nextAvailableAt: z.iso.datetime(),
});
export const partnerManualBoostStatusResponseSchema = z.object({
    boost: partnerManualBoostSchema.nullable(),
    canGrant: z.boolean(),
});
